import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CookieBanner } from "@/components/CookieBanner";
import { CartProvider } from "@/contexts/CartContext";
import { AuthProvider } from "@/contexts/AuthContext";
import Index from "./pages/Index";
import Catalogo from "./pages/Catalogo";
import Prodotto from "./pages/Prodotto";
import Carrello from "./pages/Carrello";
import Checkout from "./pages/Checkout";
import Account from "./pages/Account";
import Privacy from "./pages/Privacy";
import CookiePolicy from "./pages/CookiePolicy";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false, // Disabilita completamente i retry automatici
      refetchOnWindowFocus: false, // Evita refetch quando la finestra torna in focus
      refetchOnMount: false, // Evita refetch quando il componente viene montato
      refetchOnReconnect: false, // Evita refetch quando si riconnette
      staleTime: 30 * 60 * 1000, // I dati sono considerati "freschi" per 30 minuti (aumentato)
      gcTime: 60 * 60 * 1000, // Mantieni in cache per 60 minuti (aumentato)
      // Cache più aggressiva per migliorare le performance
      cacheTime: 60 * 60 * 1000, // Alias di gcTime per compatibilità
    },
  },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <CartProvider>
        <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/catalogo" element={<Catalogo />} />
            <Route path="/prodotto/:id" element={<Prodotto />} />
            <Route path="/carrello" element={<Carrello />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/account" element={<Account />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
        </TooltipProvider>
      </CartProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
